import React, { Component } from 'react';
import { Link, NavLink } from "react-router-dom";

import config from './../config';
import EntryView from './EntryView';

class FlokkarList extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/flokkar/';

		this.state = {
			listData: []
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData() {
		// Sæki gögn til APA
		this.setState({
			listData: []
		});

		fetch(this.url)
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: json.results
				});
			}.bind(this));
	}

	render() {
		return (
			<div className={'menu'}>
				<Link to={'/leit/'}>Allir</Link>
				{
					this.state.listData.map(function(item, index) {
						return <NavLink key={index} to={'/leit//flokkur/'+item.id}>{item.heiti}</NavLink>;
					})
				}
				<NavLink to={'/leit//flokkur/innsent'}>Innsent af notendum</NavLink>
			</div>
		);
	}
}

export default FlokkarList;



// WEBPACK FOOTER //
// ./src/components/FlokkarList.js